// roles

const getters = {
	getRoles(state) {
		return state.roles;
	},
	getRole(state) {
		return state.role;
	},

};

export default getters;